export const GET_NURSE = 'nurse/getNurse'
export const GET_NURSES = 'nurse/getNurses'
export const ADD_NURSE = 'nurse/addNurse'
export const UPDATE_NURSE = 'nurse/updateNurse'
export const SET_UPDATE_NURSE = 'nurse/setNurseForUpdate'
export const DELETE_NURSE = 'nurse/deleteNurse'
export const SERVER_ERROR_NURSE = 'nurse/errorNurse'
export const ACTIVATE_NURSE = 'nurse/activateNurse'
export const CHANGE_NURSE_ROLE = 'nurse/changeNurseRole'
